import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SettingsCard from "./SettingsCard";
import { FaChevronDown } from "react-icons/fa";

const AcknowledgmentContentSection = ({
  acknowledgments,
  handleChange,
  handleChangeDnD,
  handleAdd,
  handleRemove,
  openDropdownIndex,
  handleToggle,
  handleSelectTag,
  handleInputChange,
  handleTagBlur,
  handleAckTextBlur,
  tagInputs,
  tagsData,
  loadingTag,
}) => {
  return (
    <SettingsCard
      title="Acknowledgment Content"
      subtitle="Manage acknowledgment messages and settings"
    >
      <SoftBox
        sx={{
          overflowY: "visible",
          overflowX: "auto",
          paddingRight: 1,
          paddingBottom: 1,
          width: "100%",
          "@media (min-width: 1564px)": {
            overflowX: "visible",
            paddingRight: 0,
            paddingBottom: 0,
          },
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
            "&:hover": {
              background: "#555",
            },
          },
        }}
      >
        <SoftBox
          sx={{
            "@media (max-width: 1563px)": {
              width: "max-content",
              minWidth: "1680px",
            },
            "@media (min-width: 1564px)": {
              width: "100%",
            },
          }}
        >
          {/* Table Header */}
          <Grid
            container
            spacing={2}
            alignItems="center"
            sx={{
              marginBottom: 1,
              minWidth: {
                "@media (max-width: 1563px)": "1680px",
              },
              width: {
                "@media (max-width: 1563px)": "max-content",
              },
            }}
          >
            <Grid item xs={5}>
              <SoftTypography variant="subtitle2">Acknowledgment</SoftTypography>
            </Grid>
            <Grid item xs={1} style={{ textAlign: "center" }}>
              <SoftTypography variant="subtitle2">Required?</SoftTypography>
            </Grid>
            <Grid item xs={1.5} style={{ textAlign: "center" }}>
              <SoftTypography variant="subtitle2">Display</SoftTypography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingLeft: "10px",
                  paddingRight: "20px",
                }}
              >
                <p style={{ fontSize: "14px" }}>New User</p>
                <p style={{ fontSize: "14px" }}>New Listing</p>
              </div>
            </Grid>
            <Grid item xs={2} style={{ textAlign: "center" }}>
              <SoftTypography variant="subtitle2">DND</SoftTypography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingLeft: "20px",
                  paddingRight: "30px",
                }}
              >
                <p style={{ fontSize: "14px" }}>Emails</p>
                <p style={{ fontSize: "14px" }}>SMS</p>
                <p style={{ fontSize: "14px" }}>Calls</p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <SoftTypography variant="subtitle2">Tag to Add</SoftTypography>
            </Grid>
            <Grid item xs={0.5}></Grid>
          </Grid>

          {/* Dynamic Rows */}
          <style>{`
        .custom-dropdown {
          position: relative;
          font-family: "Poppins", sans-serif;
        }
        .dropdown-input {
          width: 100%;
          padding: 10px 14px;
          font-size: 14px;
          border: 1px solid #ccc;
          border-radius: 8px;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .dropdown-input.open {
          border-color: #2563eb;
          box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
        }
        .dropdown-input input {
          flex: 1;
          border: none;
          outline: none;
          font-size: 14px;
          background: transparent;
        }
        .dropdown-icon {
          transition: transform 0.3s ease;
          color: #555;
          margin-left: 5px;
        }
        .dropdown-icon.open {
          transform: rotate(180deg);
        }
        .dropdown-list {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 8px;
          margin-top: 4px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          max-height: 220px;
          overflow-y: auto;
          z-index: 999;
          animation: dropdownFade 0.15s ease-out;
        }
        .dropdown-item {
          padding: 10px 14px;
          cursor: pointer;
          transition: background-color 0.15s;
        }
        .dropdown-item:hover {
          background-color: #f0f7ff;
        }
        .dropdown-empty,
        .dropdown-loading {
          padding: 10px;
          color: #777;
          text-align: center;
          font-size: 13px;
        }
        @keyframes dropdownFade {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

          {acknowledgments.length === 0 && (
            <SoftBox sx={{ py: 3, textAlign: "center" }}>
              <SoftTypography variant="body2" color="error" sx={{ mb: 2 }}>
                No acknowledgments are configured. Registration will not display
                consent wording until you add and save it here.
              </SoftTypography>
              <button type="button" onClick={handleAdd}>
                Add acknowledgment
              </button>
            </SoftBox>
          )}

          {acknowledgments.map((ack, index) => (
            <Grid
              container
              spacing={2}
              alignItems="center"
              key={index}
              style={{ marginBottom: 8 }}
              sx={{
                minWidth: {
                  "@media (max-width: 1563px)": "1680px",
                },
                width: {
                  "@media (max-width: 1563px)": "max-content",
                },
              }}
            >
              {/* Acknowledgment text */}
              <Grid item xs={5}>
                <input
                  type="text"
                  value={ack.text || ""}
                  onChange={(e) => handleChange(index, "text", e.target.value, { autoSave: false })}
                  onBlur={(e) =>
                    handleAckTextBlur && handleAckTextBlur(index, e.target.value)
                  }
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  }}
                  placeholder="Acknowledgment text..."
                />
              </Grid>

              {/* Required */}
              <Grid item xs={1} textAlign="center" style={{ borderRight: "1px solid gray" }}>
                <input
                  type="checkbox"
                  checked={ack.required}
                  onChange={(e) => handleChange(index, "required", e.target.checked)}
                  style={{ width: "18px", height: "18px" }}
                />
              </Grid>

              {/* Display */}
              <Grid item xs={1.5} textAlign="center" style={{ borderRight: "1px solid gray" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingLeft: "40px",
                    paddingRight: "50px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={ack.registration}
                    onChange={(e) => handleChange(index, "registration", e.target.checked)}
                    style={{ width: "18px", height: "18px" }}
                  />
                  <input
                    type="checkbox"
                    checked={ack.newBusiness}
                    onChange={(e) => handleChange(index, "newBusiness", e.target.checked)}
                    style={{ width: "18px", height: "18px" }}
                  />
                </div>
              </Grid>

              {/* DND */}
              <Grid item xs={2} textAlign="center">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingLeft: "40px",
                    paddingRight: "50px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={ack.dnd?.email || false}
                    onChange={(e) => handleChangeDnD(index, "email", e.target.checked)}
                    style={{ width: "18px", height: "18px" }}
                  />

                  <input
                    type="checkbox"
                    checked={ack.dnd?.sms || false}
                    onChange={(e) => handleChangeDnD(index, "sms", e.target.checked)}
                    style={{ width: "18px", height: "18px" }}
                  />

                  <input
                    type="checkbox"
                    checked={ack.dnd?.call || false}
                    onChange={(e) => handleChangeDnD(index, "call", e.target.checked)}
                    style={{ width: "18px", height: "18px" }}
                  />
                </div>
              </Grid>

              {/* Tag Dropdown with Input */}
              <Grid item xs={2}>
                <div className="custom-dropdown">
                  <div
                    className={`dropdown-input ${openDropdownIndex === index ? "open" : ""}`}
                    onClick={() => handleToggle(index)}
                    style={{
                      position: "relative",
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      paddingRight: "35px",
                      transition: "border-color 0.2s ease",
                    }}
                  >
                    <input
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        padding: "10px 0 10px 12px",
                        border: "none",
                        outline: "none",
                        fontSize: "14px",
                        background: "transparent",
                      }}
                      type="text"
                      value={tagInputs[index] || ack?.tag || ""}
                      placeholder="Type or select tag..."
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      onBlur={(e) =>
                        handleTagBlur && handleTagBlur(index, e.target.value)
                      }
                      onFocus={() => handleToggle(index)}
                    />

                    <FaChevronDown
                      className={`dropdown-icon ${openDropdownIndex === index ? "open" : ""}`}
                      style={{ cursor: "pointer" }}
                    />
                  </div>

                  {openDropdownIndex === index && (
                    <div className="dropdown-list">
                      {loadingTag ? (
                        <div className="dropdown-loading">Loading...</div>
                      ) : tagsData.length > 0 ? (
                        tagsData.map((tag) => (
                          <div
                            key={tag.id || tag._id}
                            className="dropdown-item"
                            onClick={() => handleSelectTag(index, tag)}
                          >
                            {tag.name}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-empty">No tags found</div>
                      )}
                    </div>
                  )}
                </div>
              </Grid>

              {/* Add / Remove Buttons */}
              <Grid item xs={0.5} display="flex" alignItems="center" justifyContent="center">
                {acknowledgments.length > 1 && index !== 0 && (
                  <button
                    type="button"
                    onClick={() => handleRemove(index)}
                    style={{
                      border: "1px solid #000",
                      borderRadius: "4px",
                      width: "28px",
                      height: "28px",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                  >
                    –
                  </button>
                )}
                {index === acknowledgments.length - 1 && (
                  <button
                    type="button"
                    onClick={handleAdd}
                    style={{
                      border: "1px solid #000",
                      borderRadius: "4px",
                      width: "28px",
                      height: "28px",
                      fontSize: "18px",
                      cursor: "pointer",
                      marginLeft: "5px",
                    }}
                  >
                    +
                  </button>
                )}
              </Grid>
            </Grid>
          ))}
        </SoftBox>
      </SoftBox>
    </SettingsCard>
  );
};

export default AcknowledgmentContentSection;
